import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Experience.css";

const Experience = () => {
  AOS.init();
  
  const experiences = [
    {
      title: "Software Development Engineer-2",
      company: "Mobile Premier League (MPL)",
      location: "Bengaluru, KA",
      period: "July 2023 – Present",
      achievements: [
        "Migrated MPL's main website to Next.js 14 with RSC and SSR, improving SEO, rendering performance, and scalability for millions of users.",
        "Achieved 18% faster load speed and 8% higher conversions by optimising Core Web Vitals, caching strategies, and code-splitting.",
        "Implemented a microfrontend architecture with separate repositories for module-wise code, enabling faster development, independent deployments, and improved scalability.",
        "Developed a 2D marketing game using Phaser.io with TypeScript and Vite, designed for distribution via WhatsApp to engage users.",
        "Developed a Ludo game using HTML, CSS, JavaScript, and Canvas, published on the Play Store as a free-to-play title to drive user acquisition and convert players into real-money gaming (RMG) users.",
        "Built reusable UI component libraries using React + TypeScript to streamline development across multiple projects.",
        "Mentored junior developers on React best practices, microfrontend architecture, and performance optimization."
      ],
      icon: "🚀"
    },
    {
      title: "Software Development Engineer-1",
      company: "Mobile Premier League (MPL)",
      location: "Bengaluru, KA",
      period: "June 2021 – June 2023",
      achievements: [
        "Modernized the frontend by transforming React class components into functional components, leveraging hooks for improved readability, maintainability, and performance.",
        "Contributed to the development of company tools using Node.js for backend services and React class components for frontend user interfaces.",
        "Built interactive web applications with a focus on performance optimization and code modularity.",
        "Maintained and upgraded existing applications by debugging issues and enhancing features.",
        "Collaborated with cross-functional teams to deliver scalable and efficient solutions within tight deadlines.",
        "Gained proficiency in JavaScript/TypeScript and React and Express.js, ensuring clean and reusable code practices.",
        "Participated in design discussions, code reviews, and sprint planning, ensuring best practices in development."
      ],
      icon: "💻"
    }
  ];

  return (
    <div className="experience-container">
      <h1>Professional Experience</h1>
      <div className="experience-timeline">
        {experiences.map((exp, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-offset="10"
            data-aos-delay={50 * index}
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            className="experience-card"
          >
            <div className="experience-header">
              <div className="experience-icon">{exp.icon}</div>
              <div className="experience-title-section">
                <h2>{exp.title}</h2>
                <h3>{exp.company}</h3>
                <div className="experience-meta">
                  <span className="location">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
                    </svg>
                    {exp.location}
                  </span>
                  <span className="period">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="currentColor"/>
                    </svg>
                    {exp.period}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="achievements-list">
              {exp.achievements.map((achievement, idx) => (
                <div key={idx} className="achievement-item">
                  <span className="achievement-bullet">▸</span>
                  <p>{achievement}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;

